import type * as React from 'react'
import { cn } from '@/lib/utils'

// Inline count pill for list rows, tabs and buttons. The overlay variant that
// sits on top of a nav icon is `NavBadge` in NavBar.tsx — this one flows with
// the surrounding text instead of being absolutely positioned.
export function CountBadge({
  count,
  className,
  ...rest
}: { count: number } & React.ComponentProps<'span'>) {
  if (count <= 0) return null
  return (
    <span
      {...rest}
      className={cn(
        'min-w-4 h-4 px-1 inline-flex items-center justify-center rounded-full bg-primary text-primary-foreground text-[10px] font-semibold',
        className,
      )}
    >
      {count}
    </span>
  )
}
